import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import image1 from "../../Images/sweepydo_image9.jpg";
import image2 from "../../Images/sweepydo_image17.jpg";
import image3 from "../../Images/sweepydo_image16.jpg";
import image4 from "../../Images/sweepydo_image11.jpg";
import image5 from "../../Images/sweepydo_image8.jpg";
import image6 from "../../Images/sweepydo_image21.jpg";
import image13 from "../../Images/sweepydo_image13.jpg";
import {FaHome, FaBroom, FaBuilding, FaWindowMaximize, FaCouch, FaTruckMoving } from "react-icons/fa";

const Services = () => {
  const services = [{
    title: "Kitchen Cleaning",
    image: image1
  }, {
    title: "Window Cleaning",
    image: image2
  }, {
    title: "Utensil Cleaning",
    image: image3
  }, {
    title: "Bathroom Cleaning",
    image: image4
  }, {
    title: "Sweeping Cleaning",
    image: image5
  }, {
    title: "Dusting",
    image: image6
  }];
  const featureServices = [{
    icon: <FaHome size={40} />,
    title: "Residential Cleaning"
  }, {
    icon: <FaBuilding size={40} />,
    title: "Commercial Cleaning"
  }, {
    icon: <FaBroom size={40} />,
    title: "Deep Cleaning"
  }, {
    icon: <FaWindowMaximize size={40} />,
    title: "Window Cleaning"
  }, {
    icon: <FaCouch size={40} />,
    title: "Carpet & Upholstery Cleaning"
  }, {
    icon: <FaTruckMoving size={40} />,
    title: "Move-In/Move-Out Cleaning"
  }];
  return <>
      
      <section className="d-flex flex-column flex-md-row align-items-center justify-content-between" style={{
      minHeight: "260px",
      // height: "220px",
      color: "#121313",
      padding: "20px clamp(20px, 5vw, 60px)",
      backgroundImage: `url(${image13})`,
      backgroundSize: "cover",
      backgroundPosition: "center top",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#f5f5f5",
      position: "relative",
      overflow: "hidden",
      fontFamily: "'Montserrat', sans-serif",
      height: "450px"
    }}>

  <div style={{
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(255, 255, 255, 0.45)",
        zIndex: 0
      }}></div>

  {/* Title */}
  <div style={{
        position: "relative",
        zIndex: 1,
        flex: 1,
        textAlign: "center",
        marginBottom: "10px"
      }}>
    <h1 className="fw-bold" style={{
          fontSize: "clamp(34px, 4vw, 58px)",
          margin: 0,
          fontWeight: "700"
        }}>
      Services
    </h1>
  </div>

  <div style={{
        position: "relative",
        zIndex: 1,
        flex: 1,
        textAlign: "center"
      }}>
    <div style={{
          fontSize: "clamp(14px, 1.2vw, 16px)",
          color: "#555",
          fontWeight: "500"
        }}>
 <span style={{
            cursor: "pointer",
            color: "#6A20Af"
          }} onClick={() => window.location.href = "/"}>
        Home
      </span>{" "}
      &gt; <span>Services</span>
    </div>
  </div>
</section>
<section style={{
      padding: "50px 15px",
      backgroundColor: "#f5f5f5"
    }}>
  <Container>
    <Row className="g-4">
      {services.map((service, index) => <Col lg={4} md={6} sm={12} xs={12} key={index}>
          <Card className="h-100 shadow-sm border-0" style={{
              borderRadius: "14px",
              overflow: "hidden"
            }}>
            <div style={{
                width: "100%",
                height: "250px",
                overflow: "hidden",
                backgroundColor: "#fff"
              }}>
              <Card.Img variant="top" src={service.image} style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block"
                }} />
            </div>

            <Card.Body className="text-center" style={{
                padding: "20px"
              }}>
              <Card.Title style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "0"
                }}>
                {service.title}
              </Card.Title>
            </Card.Body>
          </Card>
        </Col>)}
    </Row>
  </Container>
</section>
  
      <section style={{
      backgroundColor: "#eef3f3",
      padding: "60px 15px"
    }}>
        <Container>
          <Row className="mb-5 align-items-start flex-column flex-lg-row">
            <Col lg={6}>
              <p style={{
              fontSize: "12px",
              fontWeight: "700",
              letterSpacing: "2px"
            }}>
                SOME OF OUR FEATURES
              </p>
              <h1 style={{
              fontSize: "clamp(28px, 5vw, 52px)",
              fontWeight: "700",
              lineHeight: "1.2"
            }}>
                The <span style={{
                color: "#6A20Af"
              }}>benefits</span> that
                will <br />
                make you comfort.
              </h1>
            </Col>
            {/* <Col lg={6}>
              <p style={{ color: "#666", lineHeight: "1.8" }}>
                At vero eos et accusamus et iusto odio dignissimos ducimus qui
                blanditiis praesentium voluptatum deleniti atque.
              </p>
             </Col> */}
          </Row>

          <Row>
            {featureServices.map((item, index) => <Col lg={4} md={6} sm={12} key={index} className="mb-5">
                <div className="text-center">
                  <div style={{
                color: "#6A20Af",
                marginBottom: "20px"
              }}>
                    {item.icon}
                  </div>
                  <h5 style={{
                fontWeight: "700"
              }}>{item.title}</h5>
                  <p style={{
                color: "#666",
                fontSize: "14px"
              }}>
                    Transform your environment with reliable, detailed cleaning
                    services for ultimate satisfaction.
                  </p>
                 
                </div>
              </Col>)}
          </Row>
        </Container>
      </section>
    </>;
};
export default Services;
